import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Lock } from 'lucide-react';
export function FinalPricingCTA() {
  return <section className="py-12 md:py-16 bg-amber-500/5 text-teal-900 text-center" data-id="element-86">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-87">
        <div className="text-4xl mb-4" data-id="element-88">🎓</div>
        <h2 className="text-2xl md:text-3xl font-bold font-heading mb-2" data-id="element-89">
          "Desde hoy, la comunicación en tu casa tiene sistema."
        </h2>
        <p className="text-amber-600 font-bold text-sm uppercase tracking-wider mb-8" data-id="element-90">
          Última oportunidad — elegí tu plan
        </p>

        <div className="flex justify-center gap-4 text-xs text-stone-500 mb-10" data-id="element-91">
          <span className="flex items-center" data-id="element-92">
            <ShieldCheck className="w-3 h-3 mr-1" data-id="element-93" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-94">
            <Zap className="w-3 h-3 mr-1" data-id="element-95" /> Acceso inmediato
          </span>
          <span className="flex items-center" data-id="element-96">
            <Lock className="w-3 h-3 mr-1" data-id="element-97" /> Pago seguro
          </span>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 text-left max-w-2xl mx-auto" data-id="element-98">
          {/* Base */}
          <div className="bg-white border border-stone-200 shadow-sm rounded-xl p-6" data-id="element-99">
            <h3 className="font-bold text-teal-700 mb-1" data-id="element-100">
              📘 MÉTODO CONECTA-TEA — PLAN BASE
            </h3>
            <p className="text-xs text-stone-500 mb-4" data-id="element-101">5 Tomos + 5 Bonos</p>
            <div className="flex items-baseline gap-2 mb-4" data-id="element-102">
              <span className="text-stone-400 line-through text-sm" data-id="element-103">
                $40.000
              </span>
              <span className="text-2xl font-bold text-teal-900" data-id="element-104">$19.990</span>
            </div>
            <Button variant="primary" className="w-full" href="https://tupuntodigital.shop/cart/46125310148781:1" data-id="element-105">
              QUIERO EL PLAN BASE
            </Button>
          </div>

          {/* Premium */}
          <div className="bg-white border border-amber-500/40 shadow-md rounded-xl p-6 relative" data-id="element-106">
            <div className="absolute -top-3 left-4 bg-amber-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-107">
              ⭐ EL MÁS ELEGIDO
            </div>
            <h3 className="font-bold text-amber-600 mb-1 mt-1" data-id="element-108">
              🏆 MÉTODO CONECTA-TEA + PROTOCOLO DE PAZ
            </h3>
            <p className="text-xs text-stone-600 mb-4" data-id="element-109">
              Para familias que quieren todas las herramientas listas
            </p>
            <div className="flex items-baseline gap-2 mb-4" data-id="element-110">
              <span className="text-stone-400 line-through text-sm" data-id="element-111">
                $55.000 ARS
              </span>
              <span className="text-2xl font-bold text-teal-900" data-id="element-112">
                $27.990 ARS
              </span>
            </div>
            <Button variant="amber" className="w-full" href="https://tupuntodigital.shop/cart/46125322731693:1" data-id="element-113">
              QUIERO EL SISTEMA COMPLETO
            </Button>
          </div>
        </div>

        <div className="mt-8 text-xs text-stone-500" data-id="element-114">
          Mercado Pago | Tarjeta | Transferencia
        </div>
      </div>
    </section>;
}